import { render, staticRenderFns } from "./action.vue?vue&type=template&id=831c4f98"
import script from "./action.vue?vue&type=script&lang=ts"
export * from "./action.vue?vue&type=script&lang=ts"
import style0 from "./action.vue?vue&type=style&index=0&id=831c4f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports